import { Component } from '@angular/core';

@Component({
  selector: 'app-combination-chart',
  template: '<app-chart-output></app-chart-output>',
  styleUrls: []
})
export class CombinationChartComponentCustom {

}
